import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API } from '../App';
import { FileText, Scale } from 'lucide-react';

const Terms = () => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/public/pages/terms`)
      .then(res => {
        setPage(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-electric-cyan"></div>
      </div>
    );
  }

  const sections = page?.content?.sections || [
    { title: 'Acceptance of Terms', text: 'By accessing and using PhysicsCo services, you agree to be bound by these Terms of Service.' },
    { title: 'Services', text: 'PhysicsCo provides online tutoring services for Physics and Mathematics across various international curricula.' },
    { title: 'Payment', text: 'All fees are payable in advance. Refunds are subject to our cancellation policy.' },
    { title: 'Cancellation', text: 'Classes must be rescheduled or cancelled at least 24 hours in advance.' },
    { title: 'Intellectual Property', text: 'All course materials remain the property of PhysicsCo.' }
  ];

  return (
    <div className="py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 bg-electric-cyan/10 border border-electric-cyan/30 rounded-full px-4 py-2 mb-6">
            <Scale className="w-4 h-4 text-electric-cyan" />
            <span className="text-electric-cyan text-sm font-medium">Legal</span>
          </div>
          <h1 className="font-outfit text-4xl md:text-5xl font-bold text-white mb-4" data-testid="terms-title">
            {page?.title || 'Terms of Service'}
          </h1>
          <p className="text-slate-400">
            Last updated: January 2024
          </p>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="glass-card p-8"
        >
          {sections.map((section, idx) => (
            <div key={idx} className={idx > 0 ? 'mt-8 pt-8 border-t border-white/10' : ''}>
              <h2 className="font-outfit text-xl font-semibold text-white mb-3">
                {idx + 1}. {section.title}
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {section.text}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
